<template>
  <page>
    <template slot='content'>
      <os-list-descarte></os-list-descarte>
    </template>
  </page>
</template>

<script>
import Page from '@/components/Page'
import OsListDescarte from '@/components/Borracharia/OsListDescarte'

export default {
  components: {
    Page,
    OsListDescarte,
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  created () {
    const dsColaborador = this.$store.getters['filial/filial']
    this.$store.dispatch('filial/actionSidebar')
  },

  data() {
    return {
      isSidebarOpen: false,
      breadcrumbItems: [
        {
          text: 'Ordens para atendimento',
          active: true
        }
      ],
      timer: ''
    }
  },
  methods: {
    reloadPage() {
      const host = window.location.pathname;

      this.timer = setTimeout(() => {
        if (host == "/" || host == "/osPreventiva") {
          this.$store.dispatch("os/fetchFromApi", {});
        } else if (host == '/osExterna') {
          this.$store.dispatch('os/fetchFromApiExterna')
        }
        this.reloadPage();
      }, 1000 * 5);
      console.log(this.timer)

    }
  }
}
</script>
